import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailStickyViewRevamp from "./component";
import { createOrder } from "../checkout-info/actions";
import { updateProfile } from "../../au.configuration/actions";

const mapStateToProps = ({
    carDetails: {
        content
    },
    user: {
        isLoggedIn,
        secureToken,
        isUserZeroDpVariant
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    checkout: {
        order,
        order: { orderId},
        personalDetails
    },
    config: {
        testDriveConfig
    }
}) => ({
    content,
    isLoggedIn,
    secureToken,
    userTradeInData,
    tradeInToggleSelected,
    order,
    isUserZeroDpVariant,
    personalDetails,
    orderId,
    testDriveConfig
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createOrderConnect: createOrder,
    updateProfileConnect: updateProfile
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDetailStickyViewRevamp);
